import DefaultProps from '../../commonTypes/defaultprops.types';
import { LinkProps } from '../Link/link.types';
import { TeamLogoTypes } from '../TeamLogo/teamLogo.types';

export enum LineScoreTypes {
  FULL = 'full',
  MINI = 'mini',
}

export enum LineScoreTextTypes {
  INNING_NOT_PLAYED = 'X',
  SPACER = ' ',
}

export interface LineScoreProps extends DefaultProps {
  type?: LineScoreTypes;
  awayName: string;
  homeName: string;
  complete?: boolean;
  currentInning?: number;
  inningHalf?: undefined | 'top' | 'bottom';
  scheduledInnings?: number;
  inningsData?: InningData[];
  totalsData: TotalsData;
  maxWidth?: string;
  collapsed?: boolean;
  collapsedUntilInning?: number;
  winner?: 'away' | 'home';
  extraRowSpacing?: string;
  headerAbbr?: string[];
  inningsFixedWidth?: string;
  maxInningsInView?: number;
  awayTeamId?: number;
  homeTeamId?: number;
  logoHeight?: string;
  logoOffset?: string;
  homeLinkProps?: LinkProps;
  awayLinkProps?: LinkProps;
  homeSplitSquad?: string;
  awaySplitSquad?: string;
  teamLogoType?: TeamLogoTypes;
}

export interface InningData {
  num: number;
  home: InningTeamData;
  away: InningTeamData;
}

export interface InningTeamData {
  runs?: number;
}

export interface TotalsData {
  home: TotalTeamData;
  away: TotalTeamData;
}

export interface TotalTeamData {
  runs: number;
  hits: number;
  errors: number;
}
